import { ChangeDetectionStrategy, Component, input, signal, WritableSignal } from '@angular/core';
import { disabled, form, FormField, maxLength, minLength, required } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EntityDeletionReason, PatchEntityStateDto } from '@workspace/data-types';
import { StateReasonDisplayPipe } from '@workspace/ng-data-access';
import { AbstractSignalFormComponent } from '../../../abstract';

export interface EntityStateFormModel {
  status: PatchEntityStateDto['status'];
  reason: EntityDeletionReason;
  note: string;
}

@Component({
  selector: 'aura-entity-state-form',
  templateUrl: './entity-state-form.component.html',
  imports: [FormField, MatFormFieldModule, MatSelectModule, StateReasonDisplayPipe, MatInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraEntityStateFormComponent extends AbstractSignalFormComponent<
  PatchEntityStateDto,
  EntityStateFormModel
> {
  isAdmin = input(true);

  override model: WritableSignal<EntityStateFormModel> = signal<EntityStateFormModel>({
    status: undefined as unknown as PatchEntityStateDto['status'],
    reason: EntityDeletionReason.USER_REQUEST,
    note: '',
  });

  entityReasonValues = Object.values(EntityDeletionReason);

  override formTree = form(this.model, (b) => {
    required(b.status);
    required(b.reason, { when: () => this.isAdmin() });
    disabled(b.reason, { when: () => this.allReadonly() || this.allDisable() });
    minLength(b.note, 10);
    maxLength(b.note, 150);
  });

  protected override buildModelFromDto(dto: PatchEntityStateDto): EntityStateFormModel {
    return {
      status: dto.status,
      reason: dto.reason || EntityDeletionReason.USER_REQUEST,
      note: dto.note || '',
    };
  }

  protected override buildDtoFromModel(model: EntityStateFormModel): PatchEntityStateDto {
    return {
      status: model.status,
      reason: model.reason,
      note: model.note || undefined,
    };
  }
}
